import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { RowTitleTextCellProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { Grid, TableCell } from "@mui/material";
import useValueFormatter from "../../useValueFormatter";
import { Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const RowTitleTextCell: React.FC<RowTitleTextCellProps> = ({
  row,
  index,
  depth,
  cellValue,
  propertyName,
  className,
  colSpan,
  inlineExpansion,
  expanded,
}) => {
  const { getFormattedValue } = useValueFormatter();

  return (
    <TableCell
      className={clsx(
        cssExports.tableCell,
        cssExports.freezeCell,
        cssExports.titleCell,
        cellValue.isTextSmall ? cssExports.textSmall : "",
        className,
        cellValue?.className
      )}
      align={cellValue?.alignment}
      style={{
        width: cellValue?.width,
        maxWidth: cellValue?.maxWidth,
      }}
      colSpan={colSpan}
    >
      <Grid container wrap="nowrap" direction="row">
        <Grid item xs>
          {getFormattedValue(cellValue?.formatter ? cellValue.formatter(row, index, depth) : row[propertyName])}
          {inlineExpansion ? (
            <span className={cssExports.expandableIconInline}>
              {expanded ? (
                <Icon icon={IconDefinitionConstants.WChevronSmallUp} />
              ) : (
                <Icon icon={IconDefinitionConstants.WChevronSmallDown} />
              )}
            </span>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </TableCell>
  );
};

export default RowTitleTextCell;
